import { useState } from "react";
import Dropdown, { type DropdownOption } from "@/components/base/Dropdown";

export interface FilterGroup {
  key: string;
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

interface FilterBarProps {
  groups: FilterGroup[];
  sortOptions: DropdownOption[];
  sortValue: string;
  onSortChange: (value: string) => void;
  onReset?: () => void;
}

export default function FilterBar({
  groups,
  sortOptions,
  sortValue,
  onSortChange,
  onReset,
}: FilterBarProps) {
  const [collapsed, setCollapsed] = useState(false);

  return (
    <div className="w-full rounded-lg bg-background-100/70 border border-background-200">
      <div className="flex items-center justify-between px-4 py-3 md:hidden">
        <span className="text-sm font-medium text-foreground-800">筛选条件</span>
        <button
          type="button"
          onClick={() => setCollapsed((prev) => !prev)}
          className="inline-flex items-center gap-1 text-sm text-primary-600 cursor-pointer"
        >
          <i className="ri-filter-3-line"></i>
          {collapsed ? "展开" : "收起"}
          <i
            className={`ri-arrow-down-s-line transition-transform ${
              collapsed ? "" : "rotate-180"
            }`}
          ></i>
        </button>
      </div>

      <div className={`${collapsed ? "hidden md:block" : "block"} px-4 py-4 md:py-4 space-y-3.5`}>
        {groups.map((group) => (
          <div key={group.key} className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4">
            <span className="text-sm text-foreground-500 md:w-12 shrink-0 md:pt-1">
              {group.label}
            </span>
            <div className="flex flex-wrap gap-2">
              {group.options.map((option) => {
                const active = option === group.value;
                return (
                  <button
                    key={option}
                    type="button"
                    onClick={() => group.onChange(option)}
                    className={`px-3 py-1.5 rounded-md text-sm cursor-pointer whitespace-nowrap transition-colors ${
                      active
                        ? "bg-primary-500 text-background-50 font-medium"
                        : "bg-background-50 text-foreground-700 border border-background-200 hover:text-primary-600 hover:border-primary-300"
                    }`}
                  >
                    {option}
                  </button>
                );
              })}
            </div>
          </div>
        ))}

        <div className="flex items-center justify-between flex-wrap gap-3 pt-3 border-t border-background-200">
          <div className="flex items-center gap-3">
            <span className="text-sm text-foreground-500">排序</span>
            <Dropdown value={sortValue} options={sortOptions} onChange={onSortChange} />
          </div>
          {onReset ? (
            <button
              type="button"
              onClick={onReset}
              className="inline-flex items-center gap-1 text-sm text-foreground-500 hover:text-primary-600 cursor-pointer transition-colors"
            >
              <i className="ri-refresh-line"></i>
              重置筛选
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}